<template>
  <div>
    <div class="page-header">
      <div class="container-fluid d-flex align-items-center justify-content-between">
       <h4 class="h no-margin-bottom">Grup İşlemler</h4>
       <div class="right-menu list-inline no-margin-bottom">
          <router-link to="/defines/cihazgrup"><button type="submit" class="btn submit bg-dark text-light mr-w">Ana Gruplar</button>
          </router-link>
          <router-link to="/liste/cihaz"><button type="submit" class="btn submit bg-dark text-light">Cihazlar</button>
          </router-link>
       </div>
      </div>
    </div>

  <section class="no-padding-top no-padding-bottom">
      <div class="container-fluid">
          <div class="block" >
            <div class="block-body">
             <div class="form-group">
              <div class="row">
              <div class="col-lg-3 col-12">
                <label class="form-control-label dashtext-3">Cihaz Anagrup</label>
                <select @change="onChange($event)" v-model="newPost.grupid"  class="form-control">
                  <option value="0">Cihaz Grubunu seç</option>
                  <option v-for="option in grup" :value="option.id" :key="option.id">{{ option.alias }}
                  </option>
                </select>
              </div>
               <div class="col-lg-3 col-12">
                <label class="form-control-label dashtext-3">Kodu</label>
                <input placeholder="Min 6 karakter" type="text" class="form-control" v-model="newPost.kodu"/>
              </div>
               <div class="col-lg-3 col-12">
                <label class="form-control-label dashtext-3">Alias</label>
                <input @keyup="this.$helper.tabloarama" id="arama" placeholder="Min 6 karakter" type="text" class="form-control" v-model="newPost.alias"/>  
              </div> 
              <div class="col-lg-3 col-12">
                <label class="form-control-label dashtext-3">Ağrlık</label>
                <input placeholder="Kilogram" type="text" class="form-control" v-model="newPost.agirlik"/>
              </div>
            </div>
            <div class="row mt-3">
               <div class="col-lg-3 col-12">
                <label class="form-control-label dashtext-3">Genişlik</label>
                <input placeholder="Santimetre" type="text" class="form-control" v-model="newPost.genislik"/>
              </div>
               <div class="col-lg-3 col-12">
                <label class="form-control-label dashtext-3">Derinlik</label>
                <input placeholder="Santimetre" type="text" class="form-control" v-model="newPost.derinlik"/>
              </div>
               <div class="col-lg-3 col-12">
                <label class="form-control-label dashtext-3">Yükseklik</label>
                <input placeholder="Santimetre" type="text" class="form-control" v-model="newPost.yukseklik"/>
              </div>
               <div class="col-lg-3 col-12 mt-4 p-2">
<button @click="sendNewPost()" class="btn btn-danger w-100">{{progres.mesaj}}</button>
              </div>                                                        
            </div>
          </div>
        </div>
      </div>
              <div class="row">
                <div class="col-12" >
                <div class="block margin-bottom-sm">
                  <div class="table-responsive"> 
                    <table id="tablo" class="table">
                      <thead>
                        <tr>
                          <th>Anakod</th>
                          <th>Grup</th>
                          <th>Kod</th>
                          <th>Alias</th>
                          <th>Genişlik</th>
                          <th>Yükseklik</th>
                          <th>Derinlik</th>
                          <th>Ağırlık</th>
                          <th>Düzenle</th>
                          
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="caris in posts" :key="caris.id" >
                          <td>{{caris.akod}}</td>
                          <td>{{caris.alias}}</td>
                          <td>{{caris.mkod}}</td>
                          <td>{{caris.malias}}</td>
                          <td>{{caris.genislik}} cm.</td>
                          <td>{{caris.yukseklik}} cm.</td>
                          <td>{{caris.derinlik}} cm.</td>
                          <td>{{caris.agirlik}} kg.</td>
                          <td v-if="$helper.sayfayetki(516410)"  class="text-info">
                      <router-link :to="`/duzen/altgrup/${caris.id}`">Düzenle</router-link>
                    </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                </div>
              </div>      
            <div class="row">
              <div class="col-12">
                <div class="footer__block block no-margin-bottom">
                  <div v-if="errors && errors.length" class="container-fluid text-center">
                    <div class="loading dashtext-2">Veritabanı Hatası</div>
                     <ul>
                        <li v-for="(error, index) of errors" :key="index">
                          {{ index + 1 }} - {{ error.message }}
                        </li>
                      </ul>
                  </div>
                </div>
              </div>
            </div>      
    </div>
  </section>
  <div v-if="progres.inprogres" class="loading"><img src="/set/ajax-loader.gif"/></div>
</div>
</template>
<script>

  export default {  
    created() {
      this.progres.inprogres=true
      this.yetki();
      
    },
    data() {
      return {
        progres : {
        mesaj:'Bekleyiniz',
        inprogres:true
      },
        posts: [],
        errors: [],
        grup:[],
        ya:this.$request.ayar().ya,
        kid:this.$request.ayar().kid,
        table:this.$route.params.table,
        newPost:
              {
                firma : this.$request.ayar().firmaid,
                kodu :'',
                alias:'',
                grupid:0,
                table :this.$route.params.table,
                genislik:0,
                derinlik:0,
                yukseklik:0,
                agirlik:0
             }
      };
    },
    methods: {
          yetki(){ 
          if (this.$helper.sayfayetki(516410)){
            let islem =false;
            switch(this.ya) {
              case 'said':
                this.ya = 'said';
                islem = true
                break;
              case 'carid':
                this.ya='carid';
                islem = true;
                break;
              default:
                islem = true;
                this.ya = 'fid';
            }
                if(islem){this.cihazgrup(this.getir);}
          }
          else{
                alert('Bu alanı kullanım yetkiniz yok')
                this.$router.go(-1)
          }
        
        },

        cihazgrup(callback){
            this.$request.get("cihazgrup/"+this.newPost.firma)
            .then(res => {this.grup = res.results
             this.progres.mesaj="Kayıt Ekle";
             
            })
            callback()
        },
        getir(){
          let table = null
          if(this.newPost.table==="cihazaltgrup"){table = "view_cihazgrup"}
          else{table = "view_"+this.newPost.table}
         this.$request.get("/altgrup/"+this.newPost.firma+"/"+table)
            .then(
              res => {this.posts = res.results;
              this.progres.inprogres=false;

            })
          
        },

      sendNewPost() {
        if (this.newPost.kodu && this.newPost.alias && this.newPost.grupid>0){
          this.progres.inProgress = true
            this.$request.post("define/",this.newPost )
            .then( res =>{
              console.log(res)
             this.$swal("Kayıt Ekleme Başarılı")
             this.getir()
            }
          )
        .catch(err => this.$swal(err.message))
        this.progres.inProgress = false;
        }
        else{
          this.$swal("Girdileri Kontrol Et")
        }
      },
    },  
  };
</script>
<style scoped>
.highlight {
  background:lightslategray;
  color: white;
}
li{list-style: none; display:inline-block}
</style>


// WEBPACK FOOTER //
// src/views/cihaz/altgrup.vue